"use strict";

exports.__esModule = true;
exports["default"] = ProductSoftware;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ProductSoftware(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.327.063H3.673A3.608 3.608 0 0 0 .065 3.671v24.658a3.61 3.61 0 0 0 3.608 3.609h24.654a3.61 3.61 0 0 0 3.608-3.608V3.671A3.608 3.608 0 0 0 28.327.063zM13.152 17.124l-4.769 4.765c-.309.311-.715.466-1.122.466s-.813-.155-1.122-.466a1.58 1.58 0 0 1 0-2.244L9.782 16l-3.643-3.641a1.586 1.586 0 0 1 0-2.248 1.58 1.58 0 0 1 2.244 0l4.769 4.765a1.59 1.59 0 0 1 0 2.248zm11.587 5.231h-7.942a1.587 1.587 0 1 1 0-3.176h7.942a1.588 1.588 0 0 1 0 3.176z"
  }));
}